import type { CreateEnhanceProvider } from '../../types/plugin';
import type { ExpandSelectionPluginPropertyOptions } from './expandSelectionPlugin';
import type { SlateProps } from 'slate-react';
import { useExpandSelection } from './useExpandSelection';
import { telemetryContextFor } from 'modules/Apollo/types';

type ProviderComponentProps = Readonly<{
  forceExpandPicklist: boolean;
  children: React.ReactNode;
}>;

export const ProviderComponentWithExpandSelection = ({
  forceExpandPicklist,
  children,
}: ProviderComponentProps): React.ReactElement => {
  useExpandSelection({ forceExpandPicklist, context: APOLLO_QUERY_CONTEXT });

  return children as React.ReactElement;
};

export const enhanceProviderExpandSelection: CreateEnhanceProvider<
  ExpandSelectionPluginPropertyOptions
> =
  ({ pluginID, forceExpandPicklist = false }) =>
  (Component: React.ComponentType<SlateProps>) =>
    function EnhanceProviderExpandSelection(props: SlateProps) {
      return (
        <Component {...props}>
          <ProviderComponentWithExpandSelection forceExpandPicklist={forceExpandPicklist}>
            {props.children}
          </ProviderComponentWithExpandSelection>
        </Component>
      );
    };

ProviderComponentWithExpandSelection.displayName = 'ProviderComponentWithExpandSelection';

const APOLLO_QUERY_CONTEXT = telemetryContextFor(ProviderComponentWithExpandSelection);
